import React, { useState, useContext, useEffect, useLayoutEffect } from "react";
import { DispatchContext, StateContext } from "bodycodi/cmap/app/components/common/context";
import { useSelector } from "react-redux";

// components
import RollingYearSelectPop from "../../common/RollingYearSelectPop";
import SalaryDetailPop from "./detail";

// assets
import DownIcon from "bodycodi/cmap/app/img/down.png";
import RightIcon from "bodycodi/cmap/app/svg/icon_right_gray_18.svg";

// utils
import { changeDateFormat, getPayrollStatus, moneyFormatter } from "bodycodi/cmap/app/js/common";
import { api } from "bodycodi/cmap/app/js/api";

// redux
import { RootState } from "bodycodi/cmap/app/redux/store";

const SalaryStatementList = ({ updateMyPage }: any) => {
  const { seqPartnerCoach } = useSelector((state: RootState) => state.partner);
  const { dispatch } = useContext(DispatchContext);
  const { state } = useContext(StateContext);
  const [year, setYear] = useState<any>(new Date().getFullYear());
  const [payrolls, setPayrolls] = useState([]);
  const [selectedPayroll, setSelectedPayroll] = useState<any>("");
  const [refetch, setRefetch] = useState<number>(0);

  const fetchPayrolls = async () => {
    try {
      dispatch({ type: "LOADING_START" });
      await api
        .get(
          `/payroll/settlement/payrolls?seqPartnerCoach=${seqPartnerCoach}&searchDt=${`${year}-01-01`}`
        )
        .then(({ data }) => {
          setPayrolls(data);
          dispatch({ type: "LOADING_END" });
        });
    } catch (error) {
      dispatch({ type: "LOADING_END" });
      console.error(error);
    }
  };

  useEffect(() => {
    fetchPayrolls();
  }, [year, refetch]);

  useLayoutEffect(() => {
    return () => updateMyPage();
  }, []);

  const handleDatePickerOpen = () => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "NOTIFICATION_POP",
      open: { rollingYearSelectPop: true },
    });
  };

  const handleOpenDetail = (seqNewSettlementPayroll: number) => {
    setSelectedPayroll(seqNewSettlementPayroll);
    dispatch({
      type: "POP_UP_OPEN",
      id: "SALARY_DETAIL_POP",
      open: { salaryDetailPop: true },
    });
  };

  return (
    <div className="popup-body no-padding salary-statement-list">
      <div className="year-picker" onClick={handleDatePickerOpen}>
        {year} 년
        <img src={DownIcon} />
      </div>
      {!state.loading && payrolls.length === 0 ? (
        <div className="salary-statement-list empty">급여내역이 없습니다.</div>
      ) : (
        <div>
          {payrolls?.map((payroll: any) => {
            return (
              <OneStatement
                key={payroll.seqNewSettlementPayroll}
                handleOpen={handleOpenDetail}
                payroll={payroll}
              />
            );
          })}
        </div>
      )}

      <RollingYearSelectPop
        propYear={year}
        minYear={2015}
        maxYear={new Date().getFullYear()}
        onChange={(year: any) => setYear(year)}
      />
      <SalaryDetailPop seqNewSettlementPayroll={selectedPayroll} setRefetch={setRefetch} />
    </div>
  );
};

const OneStatement = ({ handleOpen, payroll }: any) => {
  return (
    <div className="one-statement" onClick={() => handleOpen(payroll.seqNewSettlementPayroll)}>
      <div className="top-part">
        <div>
          {getPayrollStatus(payroll.settlementStatus)}
          <span className="title">{payroll.payrollName}</span>
        </div>

        <div>
          <span className="price">{moneyFormatter(payroll.totalPay)}</span>
          <img src={RightIcon} />
        </div>
      </div>

      <span className="date">{`${
        changeDateFormat(payroll.payStartDt, true) +
        " ~ " +
        changeDateFormat(payroll.payEndDt, true)
      }`}</span>
    </div>
  );
};

export default SalaryStatementList;
